import {
  Box,
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import AnimatedNumber from "../../common/components/AnimatedNumber";
import ChartRenderer from "../../common/components/ChartRenderer";

const RevenueWaterfallCard = ({ waterfall }) => {
  const { t } = useTranslation("financials");

  if (!waterfall) return null;

  const barLabels = [
    t("waterfall.grossRevenue"),
    t("waterfall.totalExpenses"),
    t("waterfall.netAfterExpenses"),
    t("waterfall.totalPaid"),
    t("waterfall.totalOutstanding"),
  ];
  const barValues = [
    waterfall.gross_revenue,
    waterfall.total_expenses,
    waterfall.net_after_expenses,
    waterfall.total_paid,
    waterfall.total_outstanding,
  ];

  return (
    <Card variant="outlined" sx={{ mb: 3 }}>
      <CardContent>
        <Typography
          variant="h6"
          sx={{
            textTransform: "uppercase",
            fontWeight: 500,
            fontSize: "0.875rem",
            color: "text.secondary",
            mb: 2,
          }}
        >
          {t("waterfall.title")}
        </Typography>

        <Box sx={{ display: "flex", gap: 4, mb: 3, flexWrap: "wrap" }}>
          <Box>
            <Typography variant="body2" color="text.secondary">
              {t("waterfall.grossRevenue")}
            </Typography>
            <Typography variant="h4" sx={{ fontWeight: "bold" }}>
              <AnimatedNumber
                section="statsCards"
                value={waterfall.gross_revenue}
                isCurrency
              />
            </Typography>
          </Box>
          <Box>
            <Typography variant="body2" color="text.secondary">
              {t("waterfall.netAfterExpenses")}
            </Typography>
            <Typography variant="h4" sx={{ fontWeight: "bold" }}>
              <AnimatedNumber
                section="statsCards"
                value={waterfall.net_after_expenses}
                isCurrency
              />
            </Typography>
          </Box>
          <Box>
            <Typography variant="body2" color="text.secondary">
              {t("waterfall.totalOutstanding")}
            </Typography>
            <Typography
              variant="h4"
              sx={{ fontWeight: "bold", color: "warning.main" }}
            >
              <AnimatedNumber
                section="statsCards"
                value={waterfall.total_outstanding}
                isCurrency
              />
            </Typography>
          </Box>
        </Box>

        <Box sx={{ maxHeight: 250 }}>
          <ChartRenderer
            chartType="bar"
            labels={barLabels}
            dataValues={barValues}
            color="#009efd"
            chartTitle="Revenue Waterfall"
          />
        </Box>

        {waterfall.expenses?.length > 0 && (
          <Table size="small" sx={{ mt: 3 }}>
            <TableHead>
              <TableRow>
                <TableCell>Expense</TableCell>
                <TableCell>Assigned To</TableCell>
                <TableCell>Asset</TableCell>
                <TableCell align="right">Type</TableCell>
                <TableCell align="right">Amount</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {waterfall.expenses.map((exp) => (
                <TableRow key={exp.id}>
                  <TableCell>{exp.name}</TableCell>
                  <TableCell>{exp.user_name}</TableCell>
                  <TableCell>{exp.asset_title}</TableCell>
                  <TableCell align="right">
                    {exp.type === "static"
                      ? t("waterfall.expenseType.static")
                      : `${exp.value}%`}
                  </TableCell>
                  <TableCell align="right">
                    ${exp.calculated_amount?.toFixed(2)}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </CardContent>
    </Card>
  );
};

export default RevenueWaterfallCard;
